<template>
	<pre v-html="$t('terms.agreement6')"></pre>
</template>

<script>
export default {
	name: 'Agreement6',
};
</script>

<style scoped></style>
